<template>
  <div>
    <v-client-table :data="states" :columns="columns" :sortable="['abbreviation']">
      <template v-slot:actions="props">
        <delete-button :title="props.row.abbreviation" :record="props.row" :remove="() => remove(props.row)" />
        <button
          class="btn btn-link p-0 border-0"
          v-b-tooltip.hover
          :title="`Edit state tax rate`"
          @click="() => edit(props.row)"
        >
          <i class="far fa-edit fa-fw"></i>
        </button>
      </template>
    </v-client-table>

    <b-modal
      size="xs"
      ref="nexusModal"
      :title="`${isEdit ? 'Edit' : 'Add'} State`"
      @hidden="cancel"
      :hide-footer="true">
      <div v-if="currentItem">
        <NexusStateForm
          :currentItem="currentItem"
          :isEdit="isEdit"
          :availableStates="availableStates"
          :loading="loading"
          @submit="submit"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import NexusStateForm from './NexusStateForm';

export default {
  name: 'NexusStatesTable',
  components: {
    NexusStateForm
  },
  props: {
    states: Array,
    availableStates: Array,
    loading: Boolean
  },
  data() {
    return {
      columns: ['abbreviation', 'fixedTaxRate', 'actions'],
      currentItem: null,
      isEdit: false
    };
  },
  methods: {
    addNewState() {
      this.currentItem = {
        abbreviation: null,
        fixedTaxRate: null
      };
      this.$refs.nexusModal.show();
    },
    remove(state) {
      this.$emit('remove', state);
    },
    edit(state) {
      this.isEdit = true;
      this.currentItem = { ...state };
      this.$refs.nexusModal.show();
    },
    async submit() {
      this.$emit('submit', { ...this.currentItem });
      this.cancel();
    },
    cancel() {
      this.$refs.nexusModal.hide();
      this.currentItem = null;
      this.isEdit = false;
    }
  }
};
</script>
